import React, { FC, useEffect, useState } from 'react';
import { getModuleRecordListCache } from '@/common/asset-apis/assetModel';
import { Api } from '@cui/req';

import { AreaSelectRenderProps } from './type';

export const AreaSelectRender: FC<AreaSelectRenderProps> = ({
  field,
  targerValue,
  setViewValue,
}) => {
  const [renderData, setRenderData] = useState<any>('');

  useEffect(() => {
    if (!targerValue) {
      return;
    }
    const params: Record<any, any> = {
      moduleID: 'bd_administrative_division',
      namespaceID: 'base',
      filter: `number = '${targerValue}'`,
    };
    getModuleRecordListCache(Api, 'base', 'bd_administrative_division', params).then((res: any) => {
      const { set = [] } = res || {};
      if (set?.length > 0) {
        const findName = set[0]?.values?.find((item: any) => item.name === 'name')?.value;
        setRenderData(findName || targerValue);
      } else {
        setRenderData(targerValue);
      }
    });
  }, [targerValue]);

  useEffect(() => {
    setViewValue(renderData);
  }, [renderData]);

  return renderData;
};
export default AreaSelectRender;
